import type { CarouselImageProperty } from '../ProductImage';

import { useMemo } from 'react';

import { useGalleryContext } from '~/utilities/context/dynamic/GalleryContext';

export const useStyleVariant = () => {
  const { styleVariantsHoveredIndex, productStyleVariantIndex, styleVariants } =
    useGalleryContext();

  const productStyleVariantInfo = useMemo(
    () =>
      styleVariantsHoveredIndex !== productStyleVariantIndex && styleVariants
        ? styleVariants[styleVariantsHoveredIndex]
        : undefined,
    [styleVariants, styleVariantsHoveredIndex, productStyleVariantIndex]
  );

  const styleVariant = useMemo(() => {
    if (productStyleVariantInfo?.images) {
      const { thumbnailAltText, xlarge, large } = productStyleVariantInfo.images;
      const productImage = {
        altText: thumbnailAltText ?? '',
        url: xlarge || large || '',
      };
      const newImage: CarouselImageProperty = {
        original: productImage,
      };

      return newImage;
    }

    return null;
  }, [productStyleVariantInfo]);

  return {
    productStyleVariantInfo,
    styleVariant,
  };
};
